module.exports = __webpack_public_path__ + "static/solarproject-aa68b9b05c730fac9a37f6f03e3d06b3.png";